var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.visible)?_c('button',{staticClass:"btn-outline-primary btn-block mx-0",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.captureAndProcessScreen.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-camera mr-3",attrs:{"aria-hidden":"true"}}),_vm._v(" Capture screenshot ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }